import React, { Fragment, FC, ChangeEvent, useState } from 'react';
import { Box, Button, Grid, TextField } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { ActionFilter } from 'models/action';
import { useTranslation } from 'react-i18next';
import FilterOnStatusDropdown from 'components/users/shared/filter-on-status-dropdown/filter-on-status-dropdown.component';
import CategoryFilterDropdown from '../shared/category-filter-dropdown/category-filter-dropdown.component';
import GroupFilterDropdown from '../shared/group-filter-dropdown/group-filter-dropdown.component';
import ProductionTemplateFilter from '../shared/production-template-filter/production-template-filter.component';

type ActionsPageActionsProps = {
    onNewActionClick: () => void;
    onFilterChange: (actionFilter: ActionFilter) => void;
    groups: { _id: string; name: string }[];
};
const ActionsPageActions: FC<ActionsPageActionsProps> = ({
    onNewActionClick,
    onFilterChange,
    groups,
}: ActionsPageActionsProps) => {
    const { t: translate } = useTranslation(['lab-settings']);
    const [actionFilter, setActionFilter] = useState<ActionFilter>({
        freetext: '',
        category: '',
        active: true,
        group: '',
        productionPlanTemplate: 'ALL',
        productionValueTemplate: 'ALL',
    });

    const handleFreetextChange = (freetext: string) => {
        setActionFilter({ ...actionFilter, freetext: freetext });
        onFilterChange({ ...actionFilter, freetext: freetext });
    };
    const handleCategorySelect = (category: string) => {
        setActionFilter({ ...actionFilter, category: category });
        onFilterChange({ ...actionFilter, category: category });
    };
    const handleGroupSelect = (group: string) => {
        setActionFilter({ ...actionFilter, group: group });
        onFilterChange({ ...actionFilter, group: group });
    };
    const handleStatusSelect = (filterStatus: boolean | null) => {
        setActionFilter({ ...actionFilter, active: filterStatus });
        onFilterChange({ ...actionFilter, active: filterStatus });
    };

    const handleProductionPlanTemplateSelect = (productionPlanTemplate: string) => {
        setActionFilter({ ...actionFilter, productionPlanTemplate });
        onFilterChange({ ...actionFilter, productionPlanTemplate });
    };

    const handleProductionValueTemplateSelect = (productionValueTemplate: string) => {
        setActionFilter({ ...actionFilter, productionValueTemplate });
        onFilterChange({ ...actionFilter, productionValueTemplate });
    };

    return (
        <Fragment>
            <Box display="flex" alignItems="center">
                <Grid container spacing={1}>
                    <Grid item sm={3} xs={12}>
                        <TextField
                            fullWidth
                            id="filter-name"
                            margin="dense"
                            name="search"
                            label={translate('lab-settings:FILTER_ACTIONS')}
                            onChange={(event: ChangeEvent<HTMLInputElement>) =>
                                handleFreetextChange(event.target.value)
                            }
                        />
                    </Grid>
                    <Grid item sm={3} xs={12}>
                        <GroupFilterDropdown
                            groups={groups}
                            group={actionFilter.group}
                            onGroupSelect={handleGroupSelect}
                        />
                    </Grid>
                    <Grid item sm={2} xs={12}>
                        <CategoryFilterDropdown
                            category={actionFilter.category}
                            onCategorySelect={handleCategorySelect}
                        />
                    </Grid>
                    <Grid item sm={2} xs={12}>
                        <FilterOnStatusDropdown fullWidth statusSelected={handleStatusSelect} />
                    </Grid>
                    <Grid item sm={2} xs={12} alignSelf="center">
                        <Button variant="contained" fullWidth onClick={onNewActionClick} startIcon={<AddIcon />}>
                            {translate('lab-settings:NEW_ACTION')}
                        </Button>
                    </Grid>

                    <Grid item sm={3} xs={12}>
                        <ProductionTemplateFilter
                            templateType="plan"
                            value={actionFilter.productionPlanTemplate}
                            onSelect={handleProductionPlanTemplateSelect}
                        />
                    </Grid>

                    <Grid item sm={3} xs={12}>
                        <ProductionTemplateFilter
                            templateType="value"
                            value={actionFilter.productionValueTemplate}
                            onSelect={handleProductionValueTemplateSelect}
                        />
                    </Grid>
                </Grid>
            </Box>
        </Fragment>
    );
};

export default ActionsPageActions;
